import { CartesianTile } from '@polaris-customerweb/sharedcomponents.shared';
import { RideCondition } from './ride-condition';

export class RideConditionTileCache {
    private _maxRideConditionAgeInHours: number;
    private _tile: CartesianTile;
    private _timestamp: number;

    constructor(
        tile: CartesianTile,
        timestamp: number,
        maxRideConditionAgeInHours: number
    ) {
        this._maxRideConditionAgeInHours = maxRideConditionAgeInHours;
        this._tile = tile;
        this._timestamp = timestamp;
    }

    get maxRideConditionAgeInHours(): number {
        return this._maxRideConditionAgeInHours;
    }

    get isExpired(): boolean {
        return (
            Date.now() - this.timestamp >
            RideCondition.TIME_TO_LIVE_SECONDS * 1000
        );
    }

    get tile(): CartesianTile {
        return this._tile;
    }

    get tileId(): string {
        return this._tile.id;
    }

    get timestamp(): number {
        return this._timestamp;
    }
}
